/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type AlertHistoryTaskStateChangeFragment = {
  __typename: 'TaskStateChangeDetails'
  initiatedBySystem: boolean
  timestamp: string | null
  to: Types.TaskNotificationStatus
  backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
}

export type AlertHistoryAdAlertStatusChangeFragment = {
  __typename: 'FccAdAlertStatusChange'
  bySystem: boolean
  date: string
  to: Types.FccAdAlertStatus
  byUser: { __typename?: 'BackofficeUser'; username: string } | null
}

export type AlertHistoryTask_HubServiceNotification_Fragment = {
  __typename: 'HubServiceNotification'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_IvcTaskNotification_Fragment = {
  __typename: 'IvcTaskNotification'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_PassengerAuthentificationFallbackRequestedNotification_Fragment =
  {
    __typename: 'PassengerAuthentificationFallbackRequestedNotification'
    notificationType: Types.TaskNotificationType
    stateChanges: Array<{
      __typename: 'TaskStateChangeDetails'
      initiatedBySystem: boolean
      timestamp: string | null
      to: Types.TaskNotificationStatus
      backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
    }>
  }

export type AlertHistoryTask_PassengerUnbuckled_Fragment = {
  __typename: 'PassengerUnbuckled'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_RoadBlockageTaskNotification_Fragment = {
  __typename: 'RoadBlockageTaskNotification'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_ShiftDeviationNotification_Fragment = {
  __typename: 'ShiftDeviationNotification'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_StopAccessibilityDownvotedByDrivers_Fragment = {
  __typename: 'StopAccessibilityDownvotedByDrivers'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_StopActivationFailedNotification_Fragment = {
  __typename: 'StopActivationFailedNotification'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_StopAreaMissingActiveStopsNotification_Fragment = {
  __typename: 'StopAreaMissingActiveStopsNotification'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_StopDownVotedByDrivers_Fragment = {
  __typename: 'StopDownVotedByDrivers'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_StopPotentiallyUnreachable_Fragment = {
  __typename: 'StopPotentiallyUnreachable'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_StopValidationFailed_Fragment = {
  __typename: 'StopValidationFailed'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_TimeManagementNotification_Fragment = {
  __typename: 'TimeManagementNotification'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_TripPrebookingNoAssignment_Fragment = {
  __typename: 'TripPrebookingNoAssignment'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_VehicleAvailabilityNotification_Fragment = {
  __typename: 'VehicleAvailabilityNotification'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_VehicleIncidentNotification_Fragment = {
  __typename: 'VehicleIncidentNotification'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_VehicleSurveillanceNotification_Fragment = {
  __typename: 'VehicleSurveillanceNotification'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTask_VehicleWaypointAttendance_Fragment = {
  __typename: 'VehicleWaypointAttendance'
  notificationType: Types.TaskNotificationType
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertHistoryTaskFragment =
  | AlertHistoryTask_HubServiceNotification_Fragment
  | AlertHistoryTask_IvcTaskNotification_Fragment
  | AlertHistoryTask_PassengerAuthentificationFallbackRequestedNotification_Fragment
  | AlertHistoryTask_PassengerUnbuckled_Fragment
  | AlertHistoryTask_RoadBlockageTaskNotification_Fragment
  | AlertHistoryTask_ShiftDeviationNotification_Fragment
  | AlertHistoryTask_StopAccessibilityDownvotedByDrivers_Fragment
  | AlertHistoryTask_StopActivationFailedNotification_Fragment
  | AlertHistoryTask_StopAreaMissingActiveStopsNotification_Fragment
  | AlertHistoryTask_StopDownVotedByDrivers_Fragment
  | AlertHistoryTask_StopPotentiallyUnreachable_Fragment
  | AlertHistoryTask_StopValidationFailed_Fragment
  | AlertHistoryTask_TimeManagementNotification_Fragment
  | AlertHistoryTask_TripPrebookingNoAssignment_Fragment
  | AlertHistoryTask_VehicleAvailabilityNotification_Fragment
  | AlertHistoryTask_VehicleIncidentNotification_Fragment
  | AlertHistoryTask_VehicleSurveillanceNotification_Fragment
  | AlertHistoryTask_VehicleWaypointAttendance_Fragment

export type AlertHistoryAdAlertFragment = {
  __typename: 'FccAdAlert'
  statusChanges: Array<{
    __typename: 'FccAdAlertStatusChange'
    bySystem: boolean
    date: string
    to: Types.FccAdAlertStatus
    byUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export const AlertHistoryTaskStateChangeFragmentDoc = gql`
    fragment AlertHistoryTaskStateChange on TaskStateChangeDetails {
  __typename
  initiatedBySystem
  timestamp
  to
  backofficeUser {
    username
  }
}
    `
export const AlertHistoryTaskFragmentDoc = gql`
    fragment AlertHistoryTask on TaskNotification {
  __typename
  notificationType
  stateChanges {
    ...AlertHistoryTaskStateChange
  }
}
    `
export const AlertHistoryAdAlertStatusChangeFragmentDoc = gql`
    fragment AlertHistoryAdAlertStatusChange on FccAdAlertStatusChange {
  __typename
  bySystem
  date
  to
  byUser {
    username
  }
}
    `
export const AlertHistoryAdAlertFragmentDoc = gql`
    fragment AlertHistoryAdAlert on FccAdAlert {
  __typename
  statusChanges {
    ...AlertHistoryAdAlertStatusChange
  }
}
    `
